module.exports = "<app-entity-contact-form [crudService]=\"crudService\"></app-entity-contact-form>\n"


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/assignment/assignment-customer-form.component.html
// module id = ../../../../../src/app/components/assignment/assignment-customer-form.component.html
// module chunks = main